export default __webpack_public_path__ + "static/icon-9fb500eb8ee33d43af2b97d054ffdcab.png";